import React from 'react';
import PropTypes from 'prop-types';
import Link from './link';
import { ReactComponent as Play } from '../../../assets/icons/icono-play.svg';
import { ReactComponent as Stop } from '../../../assets/icons/iconos-simplificados-player-stop.svg';

export const buttonTypes = [
  'icon',
  'primary',
  'primary2',
  'secondaryLight',
  'secondaryDark',
  'outline'
];

/**
 * Este es el componente genérico de boton
 * @param {*} props
 */
const Button = ({
  className,
  children,
  onClick,
  txt,
  type,
  isPlaying,
  disabled,
  isLink,
  isLoading
}) =>
  isLink ? (
    <a href="#enlace" className={`button button_${type} ${className}`}>
      <span>{txt}</span>
      {(type === 'primary' || type === 'icon') &&
        !isLoading &&
        (isPlaying ? <Stop /> : <Play />)}
      {children}
    </a>
  ) : (
    <button
      className={`button button_${type} ${className}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      <span>{txt}</span>
      {(type === 'primary' || type === 'icon') &&
        !isLoading &&
        (isPlaying ? <Stop /> : <Play />)}
      {children}
    </button>
  );

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,

  /**
   * Indica el tipo de boton que queremos
   */
  type: PropTypes.oneOf(buttonTypes),

  /**
   * El texto del boton
   */
  txt: PropTypes.string,
  isPlaying: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isLink: PropTypes.bool,
  isLoading: PropTypes.bool
};

Button.defaultProps = {
  children: undefined,
  type: 'primary',
  txt: '',
  isPlaying: false,
  className: '',
  disabled: false,
  isLink: false,
  isLoading: false
};

export { Link };
export default Button;
